import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import { IDictionaryItem } from '../../../../types/IDictionaryItem';
import dictionaryService from '../../../../api/dictionary.api';
import {useStores} from "../../../../stores";

type Props = {
    update: () => void
}

const CreateModal = (props: Props) => {
    const { authStore } = useStores();
    const vacancyCompanyId = authStore.user?.vacancyCompany || null
    const [item, setItem] = useState<IDictionaryItem>({
        name: '',
        nameKZ:'',
        nameEN:'',
        description: '',
        descriptionKZ:'',
        descriptionEN:'',
        parentId: 0,
        id: 0,
        vacancyCompanyId
    })

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [error, setError] = useState<string>('')

    const handleEdit = (e: React.FormEvent) => {

        e.preventDefault()
        setError('')
        dictionaryService.create('privilege', item!).then((response: any) => {
            props.update()
            handleClose()
        }).catch(e => {
            if (e.response.status === 409) {
                setError('Льгота с таким названием существует')
            }
        })

    }

    return <>
        <Button onClick={handleShow} className='mb-3'>
            Создать
        </Button>

        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Создание льготы</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleEdit}>

                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Название</Form.Label>
                        <Form.Control type="text" placeholder="Название"
                            value={item.name} onChange={(e) => setItem({ ...item, name: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Название на казахском</Form.Label>
                        <Form.Control type="text" placeholder="Название"
                            value={item.nameKZ} onChange={(e) => setItem({ ...item, nameKZ: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Название на английском</Form.Label>
                        <Form.Control type="text" placeholder="Название"
                            value={item.nameEN} onChange={(e) => setItem({ ...item, nameEN: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Описание</Form.Label>
                        <Form.Control type="text" placeholder="Краткое описание"
                            value={item.description} onChange={(e) => setItem({ ...item, description: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Описание на казахском</Form.Label>
                        <Form.Control type="text" placeholder="Краткое описание"
                            value={item.descriptionKZ} onChange={(e) => setItem({ ...item, descriptionKZ: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Описание на английском</Form.Label>
                        <Form.Control type="text" placeholder="Краткое описание"
                            value={item.descriptionEN} onChange={(e) => setItem({ ...item, descriptionEN: e.target.value })}
                        />
                    </Form.Group>



                    {error !== '' && <p className='text-danger'>{error}</p>}
                    <Button type={"submit"}>Сохранить</Button>

                </Form>
            </Modal.Body>
        </Modal>
    </>
}

export default CreateModal